import { call, put, takeEvery, delay, takeLatest } from "redux-saga/effects";
// import { ReportEntityConstant } from "../../constants/reportConstant";

import {
  CREATE_REPORT_CUSTOM_VIEW,
  FETCH_REPORT_CUSTOM_VIEW,
  SELECT_REPORT_CUSTOM_VIEW,
  DELETE_REPORT_CUSTOM_VIEW,
  FETCH_REPORT_CUSTOM_VIEW_BY_ID,
  EDIT_REPORT_CUSTOM_VIEW_BY_ID,
  UNSELECT_REPORT_CUSTOM_VIEW,
  FETCH_JOB_UNIVERSAL_REPORT_COUNT,
  FETCH_JOB_UNIVERSAL_REPORT_LISTING,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT,
} from "./actionTypes";
import {
  createReportCustomViewSuccess,
  createReportCustomViewFailure,
  fetchReportCustomViewSuccess,
  fetchReportCustomViewFailure,
  selectReportCustomViewSuccess,
  selectReportCustomFailure,
  fetchReportCustomView,
  deleteReportCustomViewSuccess,
  deleteReportCustomViewFailure,
  fetchReportCustomViewByIdFailure,
  fetchReportCustomViewByIdSuccess,
  editReportCustomViewByIdSuccess,
  editReportCustomViewByIdFailure,
  unselectReportCustomViewFailure,
  unselectReportCustomViewSuccess,
  fetchJobUniversalReportCountSuccess,
  fetchJobUniversalReportCountFailure,
  fetchJobUniversalReportListingFailure,
  fetchJobUniversalReportListingSuccess,
  fetchJobUniversalReportJobListingSuccess,
  fetchJobUniversalReportJobListingFailure,
  fetchJobUniversalReportJobCountFailure,
  fetchJobUniversalReportJobCountSuccess
} from "./action";
import {
  createJobReportCustomView,
  getJobReportCustomViews,
  selectJobReportCustomView,
  deleteJobReportCustomView,
  getJobReportCustomViewById,
  editJobReportCustomViewById,
  unSelectAllJobReportCustomView,
  getJobReportStaticReportCountFilter,
  getJobReportStaticReportListing,
  getJobReportJobListing,
  getJobReportJobCountFilter
} from "../../helpers/backend_helper";
import { toast } from "react-toastify";

// Fetch Report Custom Views
function* workFetchReportCustomView(action) {
  const payload = action.payload;
  try {
    const response = yield call(getJobReportCustomViews, payload);
    yield put(fetchReportCustomViewSuccess(response.data, payload));
  } catch (error) {
    yield put(fetchReportCustomViewFailure(error));
  }
}

// Create Report Custom View
function* workCreateReportCustomView(action) {
  const { payload, navigate, closeFilter } = action.payload;
  try {
    const reportCustomViewResponse = yield call(
      createJobReportCustomView,
      payload
    );
    yield delay(500);
    yield put(createReportCustomViewSuccess(reportCustomViewResponse));
    toast.success("Report custom view created successfully!");
    if (navigate) {
      navigate("/reports");
    } else {
      yield put(fetchReportCustomView(payload?.type));
      if (closeFilter) {
        closeFilter();
      }
    }
  } catch (error) {
    yield put(createReportCustomViewFailure(error));
    if (error?.code === 409) {
      toast.error("Report custom view name already exists.");
    } else {
      toast.error("Error creating report custom view!");
    }
  }
}

// Select Report Custom View
function* workSelectReportCustomView(action) {
  const { id, type } = action.payload;
  try {
    const response = yield call(selectJobReportCustomView, id, type);
    yield put(selectReportCustomViewSuccess(response.data, type));
    yield put(fetchReportCustomView(type));
    toast.success("Report custom view selected successfully!");
  } catch (error) {
    yield put(selectReportCustomFailure(error));
    toast.error("Error selecting report custom view!");
  }
}

// Delete Report Custom View
function* workDeleteReportCustomView(action) {
  const { id, type } = action.payload;
  try {
    const response = yield call(deleteJobReportCustomView, id);
    yield put(deleteReportCustomViewSuccess(response.data));
    yield put(fetchReportCustomView(type));
    toast.success("Report custom view deleted successfully!");
  } catch (error) {
    yield put(deleteReportCustomViewFailure(error));
    toast.error("Error deleting report custom view!");
  }
}

// Fetch Report Custom View By Id
function* workFetchReportCustomViewById(action) {
  try {
    const response = yield call(getJobReportCustomViewById, action.payload);
    yield put(fetchReportCustomViewByIdSuccess(response.data));
  } catch (error) {
    yield put(fetchReportCustomViewByIdFailure(error));
  }
}

// Edit Report Custom View By Id
function* workEditReportCustomViewById(action) {
  const { editId, payload, navigate, closeFilter } = action.payload;
  try {
    const response = yield call(editJobReportCustomViewById, editId, payload);
    yield delay(500);
    yield put(editReportCustomViewByIdSuccess(response.data));
    toast.success("Report custom view updated successfully!");
    if (navigate) {
      navigate("/reports");
    } else {
      yield put(fetchReportCustomView(payload?.type));
      if (closeFilter) {
        closeFilter();
      }
    }
  } catch (error) {
    yield put(editReportCustomViewByIdFailure(error));
    if (error?.code === 409) {
      toast.error("Report custom view name already exists.");
    } else {
      toast.error("Error updating report custom view!");
    }
  }
}

// Unselect All Report Custom View
function* workUnselectReportCustomView(action) {
  try {
    yield call(unSelectAllJobReportCustomView, action.payload);
    yield put(unselectReportCustomViewSuccess(action.payload));
    toast.success("Report default custom view  selected");
  } catch (error) {
    yield put(unselectReportCustomViewFailure(error));
    toast.error("Error unselecting report custom view!");
  }
}

function* workFetchJobUniversalReportCount(action) {
  try {
    const response = yield call(
      getJobReportStaticReportCountFilter,
      action.payload
    );
    yield put(fetchJobUniversalReportCountSuccess(response.data));
  } catch (error) {
    yield put(fetchJobUniversalReportCountFailure(error));
  }
}

function* workFetchJobUniversalReportListing(action) {
  try {
    const response = yield call(
      getJobReportStaticReportListing,
      action.payload
    );
    yield put(fetchJobUniversalReportListingSuccess(response.data));
  } catch (error) {
    yield put(fetchJobUniversalReportListingFailure(error));
  }
}

function* workFetchJobUniversalReportJobListing(action) {
  try {
    const response = yield call(getJobReportJobListing, action.payload);
    yield put(fetchJobUniversalReportJobListingSuccess(response.data));
  } catch (error) {
    yield put(fetchJobUniversalReportJobListingFailure(error));
  }
}

function* workFetchJobUniversalReportJobCount(action) {
  try {
    const response = yield call(
      getJobReportJobCountFilter,
      action.payload
    );
    yield put(fetchJobUniversalReportJobCountSuccess(response.data));
  } catch (error) {
    yield put(fetchJobUniversalReportJobCountFailure(error));
  }
}

export default function* watchFetchReportSaga() {
  yield takeEvery(CREATE_REPORT_CUSTOM_VIEW, workCreateReportCustomView);
  yield takeEvery(FETCH_REPORT_CUSTOM_VIEW, workFetchReportCustomView);
  yield takeEvery(SELECT_REPORT_CUSTOM_VIEW, workSelectReportCustomView);
  yield takeEvery(DELETE_REPORT_CUSTOM_VIEW, workDeleteReportCustomView);
  yield takeEvery(
    FETCH_REPORT_CUSTOM_VIEW_BY_ID,
    workFetchReportCustomViewById
  );
  yield takeEvery(EDIT_REPORT_CUSTOM_VIEW_BY_ID, workEditReportCustomViewById);
  yield takeEvery(UNSELECT_REPORT_CUSTOM_VIEW, workUnselectReportCustomView);
  yield takeLatest(
    FETCH_JOB_UNIVERSAL_REPORT_COUNT,
    workFetchJobUniversalReportCount
  );
  yield takeLatest(
    FETCH_JOB_UNIVERSAL_REPORT_LISTING,
    workFetchJobUniversalReportListing
  );
  yield takeLatest(
    FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING,
    workFetchJobUniversalReportJobListing
  );
  yield takeLatest(
    FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT,
    workFetchJobUniversalReportJobCount
  );
}
